import React from 'react';

export function YesNoIcon(props: React.SVGAttributes<any>) {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_6000_12613)">
                <path
                    d="M11.0523 8.2H13.3323L7.74028 17.752V25H5.70028V17.776L0.108281 8.2H2.38828L6.70828 15.976L11.0523 8.2ZM21.1308 8.2H23.0508L13.3308 28.6H11.4108L21.1308 8.2ZM38.0423 8.2H40.0823V25.84L27.3623 12.496V25H25.3223V7.36L38.0423 20.704V8.2Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_6000_12613">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
